import * as TYPES from "./type";

interface IPayloadUserAuthCurrent {
  accessToken?: string;
  callCheck?: boolean;
}

export interface IPayloadUserLoginGoogle {
  auth: string;
}

export const userAuthCurrent = (payload: IPayloadUserAuthCurrent) => ({
  type: TYPES.AUTH_CURRENT_REQ,
  payload,
});

export const userLoginGoogle = (payload: IPayloadUserLoginGoogle) => ({
  type: TYPES.AUTH_LOGIN_GOOGLE_REQ,
  payload,
});

export const userLogoutGoogle = () => ({
  type: TYPES.AUTH_LOGOUT_GOOGLE_REQ,
});
